import { IsNotEmpty, MaxLength, IsOptional, IsString, IsArray, MinLength } from 'class-validator';

export class ResourceGroupEditDTO {

    @IsNotEmpty()
    @MaxLength(50)
    name: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    resources: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    teams: Array<string>;

}
